import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ClientMarquee } from './components/ClientMarquee';
import { About } from './components/About';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { StatsBand } from './components/StatsBand';
import { Clients } from './components/Clients';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Team } from './components/Team';
import { Commitment } from './components/Commitment';
import { Faqs } from './components/Faqs';
import { Insights } from './components/Insights';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-paper font-sans" data-id="element-0" data-mp="2whx9xpepbgdl">
      <Header data-id="element-1" data-mp="28tmfb3zlmcxr" />
      <main data-id="element-2" data-mp="28te4dhn1dhp7">
        <Hero data-id="element-3" data-mp="28sutgkvsztko" />
        <ClientMarquee data-id="element-4" data-mp="28sbbj465l56n" />
        <About data-id="element-5" data-mp="23vci6nubd29i" />
        <Services data-id="element-6" data-mp="23vupqgmff2wq" />
        <Process data-id="element-7" data-mp="23u9v6r043jyv" />
        <StatsBand data-id="element-8" data-mp="23utb6267bya9" />
        <Clients data-id="element-9" data-mp="23t8h0dnsuhcx" />
        <WhyChooseUs data-id="element-10" data-mp="3ijxoypkvdyjd" />
        <Team data-id="element-11" data-mp="3ikqzm1my986s" />
        <Commitment data-id="element-12" data-mp="3iiwaeb4natww" />
        <Faqs data-id="element-13" data-mp="3ijpbavgxap74" />
        <Insights data-id="element-14" data-mp="3ihuyk4ft23e4" />
        <FinalCta data-id="element-15" data-mp="3mlj6io8cn0zw" />
      </main>
      <Footer data-id="element-16" data-mp="3mkhmhu9cv461" />
    </div>;
}